import ResultPage from './Result'
export default ResultPage
